<template>
    <div id="settings">
        <at-modal v-model="show" title="Settings" 
            @on-confirm="handleConfirm" @on-cancel="handleCancel" 
            :show-footer="false">

            <div class="left-align left">
                <span class="section">Canvas Size</span>
            </div>

            <div class="vspace"></div>
            <div class="vspace-2"></div> 
            
            <div class="left-align">
                <div class="pitem left is-small-width inline">Width</div> 
                <at-input v-model="width" class="pitem is-small-width inline" size="small"></at-input> 
                <div class="pitem more-left is-small-width inline">Height</div> 
                <at-input v-model="height" class="pitem is-small-width inline" size="small"></at-input>
            </div>

            <div class="vspace"></div>
            <div class="vspace-2"></div> 
            <div class="vspace"></div>
            <div class="vspace-2"></div> 


            <div class="left-align left">
                <div class="section is-long-width inline">Animation</div>
                <at-radio-group class="pitem left right inline" v-model="enableAnimation" fill="#f18138">
                    <at-radio-button label="a">On</at-radio-button>
                    <at-radio-button label="b">Off</at-radio-button>
                </at-radio-group>
                <at-tooltip class="pitem inline" content="Animations are still in development. Related features may not work as expected!" placement="right"><i class="icon icon-info" style="color:gray"></i></at-tooltip>
            </div>

            <div class="vspace"></div>
            <div class="vspace-2"></div> 

            <div class="left-align">
                <div class="pitem left right is-long-width inline">Duration</div> 
                <at-input v-model="dur" class="pitem is-small-width inline" size="small"></at-input> 
                secs 
                <div class="pitem left right is-long-width inline">Total Frames {{totalFrames}}</div> 
            </div>
            
            <div class="vspace"></div>
            <div class="vspace-2"></div> 

            <div class="left-align">
                <div class="pitem left right is-long-width inline">Frames Per Second</div> 
                <at-input v-model="fps" class="pitem is-small-width inline" size="small"></at-input> 
                fps
            </div>

            <div class="vspace"></div>
            <div class="vspace-2"></div> 
            <div class="vspace"></div>
            <div class="vspace-2"></div> 

            <div class="left-align left">
                <div class="section is-long-width inline">Color Pallette</div>
                <at-radio-group class="pitem left right inline" v-model="pallette" fill="#f18138">
                    <at-radio-button label="a">Simple</at-radio-button>
                    <at-radio-button label="b">Advanced</at-radio-button>
                </at-radio-group>
            </div>

            <div class="vspace"></div>

        </at-modal>        
    </div>
</template>

<script>
import { NumberUtils } from '../../lib/bezieLib/Misc/Utils';
export default {
    name: 'Settings',
    props: ['show_settings','bezieAppObj'],
    data: function(){
        return {
            show : false,
            width: 800,
            height: 600,
            fps: 24,
            dur: 10,
            totalFrames: 240,
            pallette : "a",
            enableAnimation : "b"
        }
    },
    watch:{
        show_settings: function(val){
            this.show = this.show_settings;
            if(this.show){
                this.init();
            }
        },
        width: function(val){
            this.bezieAppObj.setDimension(this.width, this.height);
        },
        height: function(val){
            this.bezieAppObj.setDimension(this.width, this.height);
        },
        fps: function(val){
            this.bezieAppObj.setFps(this.fps);
            this.setTotalFrames();
            this.totalFrames = this.bezieAppObj.getScene().getTotalFrames();
        },
        dur: function(val){
            this.setTotalFrames();
            this.totalFrames = this.bezieAppObj.getScene().getTotalFrames();
        },
        pallette: function(val){
            this.bezieAppObj.setColorPallete( this.pallette );
            console.log("Color Pallette set as "+this.pallette);
        },
        enableAnimation: function(val){
            if(val == 'a'){
                this.bezieAppObj.featureFlags.enableAnimations = true;
            }else if(val == 'b'){
                this.bezieAppObj.featureFlags.enableAnimations = false;
            }
            console.log("Enable Animations set as "+this.bezieAppObj.featureFlags.enableAnimations);
        }
    },
    methods: {
        handleConfirm () {
            
        },
        handleCancel () {
            this.$emit('close', true);
        },
        updateAnimationFlag(flagVal){
            if(flagVal == true){
                this.enableAnimation = 'a';
            }else{
                this.enableAnimation = 'b';
            }
        },
        init(){
            console.log("settings initing");
            if(this.bezieAppObj){
                var dim = this.bezieAppObj.getDimension();
                this.width = dim[0];
                this.height = dim[1];
                this.fps = this.bezieAppObj.getFps();
                this.dur = this.bezieAppObj.getScene().getTotalFrames() / this.fps;
                this.totalFrames = this.bezieAppObj.getScene().getTotalFrames();
                this.pallette = this.bezieAppObj.getColorPallete();
                this.updateAnimationFlag(this.bezieAppObj.featureFlags.enableAnimations);
                console.log("get as "+this.pallette);
            }
        },
        setTotalFrames(){
            if(NumberUtils.isNumber([this.dur,this.fps]) && this.dur > 0 && this.fps > 0){
                this.bezieAppObj.getScene().setTotalFrames( this.dur * this.fps );
            }
        }
    },
    mounted: function(){
        this.init();
    }
}

</script>

<style scoped>


.section{
  font-size: 16px;
}

.inline{
  display: inline-block;
}

.left-align{
    text-align: left;
}

.pitem{
  vertical-align: middle;
}

.vspace{
  height: 8px;
  width: 100%;
}

.vspace-2{
  height: 4px;
  width: 100%;
}

.left{
  margin-left: 10px;
}

.more-left{
  margin-left: 40px;
}

.right{
  margin-right: 10px;
}

.is-small-width{
  width: 60px;
}

.is-long-width{
  width: 160px;
}

</style>